// Selection order and limits from submitted iOS58 AlbumDetailScreen.
export const albumIdentity = (item) =>
  `${String(item.albumSource || '').toLowerCase()}:${item.sourceId}`;
export function otherAlbumVersions(items = [], album) {
  return items.filter((item) => albumIdentity(item) !== albumIdentity(album));
}
export function artistAlbumSelection(data, album, versions = []) {
  const seen = new Set(versions.map(albumIdentity));
  return ['featuredAlbums', 'fullAlbums', 'liveAlbums', 'compilationAlbums', 'singles']
    .flatMap((key) => data?.[key]?.items || [])
    .filter((item) => {
      const key = albumIdentity(item);
      if (String(item.sourceId) === String(album.sourceId) || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, 12);
}
export function canLoadAlbumArtist(artist) {
  return (
    Boolean(artist?.slug || artist?.sourceId) &&
    !['unknown', 'null', 'undefined'].includes(
      String(artist?.sourceId ?? '')
        .trim()
        .toLowerCase(),
    )
  );
}
export function secondaryAlbumPath(item) {
  if (item.slug)
    return `/reviews/${encodeURIComponent(item.slug)}${item.sourceId ? `?${new URLSearchParams({ source_id: item.sourceId })}` : ''}`;
  if (item.albumId || item.id)
    return `/reviews/local/${encodeURIComponent(item.albumId || item.id)}`;
  return `/reviews/${encodeURIComponent(String(item.albumSource || 'APPLE_MUSIC').toLowerCase())}/${encodeURIComponent(item.sourceId)}`;
}
export function relatedParentPath(pathname, search) {
  const path = pathname.replace(/\/related-albums\/?$/, '');
  const id = new URLSearchParams(search).get('source_id');
  return path + (id ? `?${new URLSearchParams({ source_id: id })}` : '');
}
